
import { Facebook, Instagram, Twitter, Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer id="contact" className="bg-[#7E69AB] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Kover King</h3>
            <p className="text-gray-100">
              Comprehensive insurance solutions for individuals and businesses across Illinois.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Insurance Services</h4>
            <ul className="space-y-2">
              <li><a href="/insurance/auto" className="text-gray-100 hover:text-white transition">Auto Insurance</a></li>
              <li><a href="/insurance/home" className="text-gray-100 hover:text-white transition">Home Insurance</a></li>
              <li><a href="/insurance/business" className="text-gray-100 hover:text-white transition">Business Insurance</a></li>
              <li><a href="/insurance/life" className="text-gray-100 hover:text-white transition">Life Insurance</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><a href="/faq" className="text-gray-100 hover:text-white transition">FAQ</a></li>
              <li><a href="#" className="text-gray-100 hover:text-white transition">Coverage Calculator</a></li>
              <li><a href="/claims-process" className="text-gray-100 hover:text-white transition">Claims Process</a></li>
              <li><a href="/quote" className="text-gray-100 hover:text-white transition">Get a Quote</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <div className="text-gray-100 mb-4 space-y-2">
              <a href="tel:217-909-9777" className="hover:text-white transition flex items-center gap-2">
                <Phone size={20} /> 217-909-9777
              </a>
              <a href="mailto:info@koverking.com" className="hover:text-white transition flex items-center gap-2">
                <Mail size={20} /> info@koverking.com
              </a>
            </div>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-100 hover:text-white transition">
                <Facebook size={24} />
              </a>
              <a href="#" className="text-gray-100 hover:text-white transition">
                <Instagram size={24} />
              </a>
              <a href="#" className="text-gray-100 hover:text-white transition">
                <Twitter size={24} />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-300 mt-8 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-100">&copy; {new Date().getFullYear()} Kover King Insurance. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 sm:mt-0">
              <a href="/privacy-policy" className="text-gray-100 hover:text-white transition">Privacy Policy</a>
              <a href="/terms" className="text-gray-100 hover:text-white transition">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

